<script>
  import MenuSettingDetail from './menu/MenuSettingDetail.svelte';
</script>

<MenuSettingDetail />
